// extracted by mini-css-extract-plugin
module.exports = {"holder":"GoiSblx","image":"nYo8Ns0","without-photo":"fUKdLHy","withoutPhoto":"fUKdLHy"};